import { IconConfiguration } from './../types'

export const VuesticIconAliases: IconConfiguration[] = [
  {
    name: 'arrow_back_ios',
    to: 'arrow_back_ios',
  },
  {
    name: 'arrow_forward_ios',
    to: 'arrow_forward_ios',
  },
  {
    name: 'first_page',
    to: 'first_page',
  },
  {
    name: 'last_page',
    to: 'last_page',
  },
  {
    name: 'chevron_right',
    to: 'chevron_right',
  },
  {
    name: 'chevron_left',
    to: 'chevron_left',
  },
  {
    name: 'expand_more',
    to: 'expand_more',
  },
  {
    name: 'expand_less',
    to: 'expand_less',
  },
  {
    name: 'arrow_drop_down',
    to: 'arrow_drop_down',
  },
  {
    name: 'arrow_drop_up',
    to: 'arrow_drop_up',
  },
  {
    name: 'calendar_today',
    to: 'calendar_today',
  },
  {
    name: 'delete_outline',
    to: 'delete_outline',
  },
  {
    name: 'clear',
    to: 'clear',
  },
  {
    name: 'check',
    to: 'check',
  },
  {
    name: 'warning',
    to: 'warning',
  },
  {
    name: 'highlight_off',
    to: 'highlight_off',
  },
  {
    name: 'close',
    to: 'close',
  },
  {
    name: 'done',
    to: 'done',
  },
  {
    name: 'cancel',
    to: 'cancel',
  },
  {
    name: 'loop',
    to: 'loop',
  },
]
